module.exports = __webpack_public_path__ + "assets/tenBis-logo-old-4cce80.svg";